module.exports = __webpack_public_path__ + "static/media/data-cards-bg.e7b50429.png";